// src/api/index.js
import axios from 'axios';
import { showGlobalNotification } from '@/utils/notificationHandler'; // 创建统一的错误处理工具

// 导出 baseURL 以便其他组件使用
export const baseURL = 'https://library.zioyeamu.top/';
//export const baseURL = 'http://10.60.101.213:1001/';

const instance = axios.create({
    baseURL: baseURL,
    //baseURL: 'http://10.60.101.213:1001/',
    timeout: 30000
});

// 请求拦截器
instance.interceptors.request.use(
    config => {
        // 在请求发送前可以添加 loading 状态或其他逻辑
        return config;
    },
    error => {
        return Promise.reject(error);
    }
);

// 响应拦截器
instance.interceptors.response.use(
    response => {
        return response;
    },
    error => {
        let notificationMessage = '发生未知错误';

        if (error.response) {
            switch (error.response.status) {
                case 401:
                    notificationMessage = error.response.data.error || '身份验证失败，请重新登录';
                    // 检查错误信息是否为身份验证失败
                    if (error.response.data.error === '身份验证失败' && !window.location.pathname.includes('/login')) {
                        // 延迟跳转以避免中断错误处理
                        setTimeout(() => {
                            if (!window.location.pathname.includes('/login')) {
                                window.location.href = '/login';
                            }
                        }, 5000);
                    }
                    break;
                case 403:
                    notificationMessage = error.response.data.error || '权限不足，无法访问';
                    break;
                case 404:
                    notificationMessage = error.response.data.error || '请求的资源不存在';
                    break;
                case 500:
                    notificationMessage = error.response.data.error || '服务器内部错误';
                    break;
                default:
                    notificationMessage = error.response.data?.error || `请求失败: ${error.response.status}`;
            }
        } else if (error.request) {
            console.error(error);
            notificationMessage = '网络请求超时或失败，请检查网络连接';
        } else {
            notificationMessage = error.message || '请求处理过程中发生错误';
        }

        // 使用统一的错误处理方法
        showGlobalNotification(notificationMessage, 'error');

        return Promise.reject(error);
    }
);

export default instance;